import "./css/components-styles.css"

const SingleLineDivider = () => {
  return (
    <div className="single-divider"/>
  )
}

export default SingleLineDivider
